<template>
  <div>
    <authentication-forms-container :image="image">
      <b-form @submit.prevent="onSubmit" class="mt-4">
        <h4 class="mb-5 text-primary">بازیابی رمز عبور</h4>

        <form-group :validations="$v.form.email">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-1"
                label="ایمیل یا شماره تلفن همراه"
                label-for="input-1"
                description=""
                class="my-4 pt-4"
            >
              <b-form-input
                  id="input-1"
                  v-model="form.email"
                  type="text"
                  placeholder="...ایمیل یا شماره تلفن همراه خود را وارد نمایید"
                  :class="{ invalid }"
                  class="rounded-pill text-left"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>

        <b-button block pill type="submit" class="mb-4 w-100" variant="primary"
        >تایید
        </b-button>
      </b-form>
    </authentication-forms-container>
  </div>
</template>

<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import {emailOrPhone, phone} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import AuthenticationFormsContainer from "../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";

export default {
  name: "ForgetPassword1",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  data() {
    return {
      form: {
        email: "",
      },
    };
  },
  props: {
    image: {
      type: String,
      default: require('../../assets/login.png')
    }
  },
  validations: {
    form: {
      email: {required, emailOrPhone},
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (phone(this.form.email)) {
          const f = {cellphone: this.form.email};
          this.$store.dispatch("Authentication/cellphoneForgetPassword", f);
        } else {
          this.$store.dispatch("Authentication/emailForgetPassword", this.form);
        }

      }
    },
  },
};
</script>
<style scoped>

</style>